export default {
  SET_SERVICE_CONFIG: '@YOLA_TEMPLATE_GALLERY/SET_SERVICE_CONFIG',
};
